import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";

import AboutPage from "../AboutPage";

const About = () => {
  return (
    <>
      <Navbar />
      <AboutPage />
      <Footer />
    </>
  );
};

export default About;
